module.exports = "<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/cpc/sinocc.web/web.X6/www/x6.ng2/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 2